var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('chartist',{attrs:{"ratio":_vm.isMobile ? 'ct-square' : 'ct-double-octave',"type":"Line","event-handlers":_vm.eventHandlers,"data":_vm.config.data,"options":_vm.config.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }